
import Vue from "vue";
import { mapState } from "vuex";
import { download } from "@/utils";
import titleEyeIcon from "@/assets/eye.png";
import {
  BATTLEYE_R2_NEW_USE_OSS,
  buildBattleyeR2NewAssetCandidates
} from "@/constants/battleye-r2-new/assets";

export default Vue.extend({
  name: "BattleyeR2New",
  data(): { titleEyeIcon: string; useOss: boolean } {
    return {
      titleEyeIcon,
      useOss: BATTLEYE_R2_NEW_USE_OSS
    };
  },
  computed: {
    ...mapState("app", {
      isCN: "isCN",
      isMobile: "isMobile",
      oss: "oss"
    })
  },
  methods: {
    onDownload(url: string) {
      download(url);
    },
    onOpen(url: string) {
      window.open(url, "_blank");
    },
    copy(entryKey: string) {
      const html = String(this.$t(`battleyeR2New.${entryKey}`));

      if (!entryKey.startsWith("text")) {
        return html;
      }

      // 保留 i18n 里的双换行，并转成统一的段落间距。
      return html.replace(
        /(?:<br\s*\/?>\s*){2,}/gi,
        '<span class="detail-paragraph-gap"></span>'
      );
    },
    asset(assetKey: string) {
      return this.assetCandidates(assetKey)[0];
    },
    assetCandidates(assetKey: string) {
      const options = {
        assetKey,
        isCN: this.isCN,
        isMobile: this.isMobile,
        oss: this.oss
      };

      return Array.from(
        new Set([
          ...buildBattleyeR2NewAssetCandidates({
            ...options,
            useOss: this.useOss
          }),
          ...buildBattleyeR2NewAssetCandidates({
            ...options,
            useOss: !this.useOss
          })
        ])
      );
    },
    onAssetError(event: Event, candidates: string[]) {
      const element = event.target as HTMLImageElement | null;
      if (!element) {
        return;
      }

      const currentIndex = Number(element.dataset.assetFallbackIndex || "0");
      const nextIndex = currentIndex + 1;
      if (nextIndex >= candidates.length) {
        return;
      }

      element.dataset.assetFallbackIndex = String(nextIndex);
      element.src = candidates[nextIndex];
    }
  }
});
